export enum ChildbirthOBConstants {
  NOT_IMPLEMENTED = 'childbirthOB/NOT_IMPLEMENTED',
  GET_ACTION = 'childbirthOB/GET_ACTION',
  SET_ACTION = 'childbirthOB/SET_ACTION',
  SAVE_ACTION = 'childbirthOB/SAVE_ACTION',
  DELETE_ACTION = 'childbirthOB/DELETE_ACTION',
  GET_FETAL_HR = 'childbirthOB/GET_FETAL_HR',
  SET_FETAL_HR = 'childbirthOB/SET_FETAL_HR',
  SAVE_FETAL_HR = 'childbirthOB/SAVE_FETAL_HR',
  DELETE_FETAL_HR = 'childbirthOB/DELETE_FETAL_HR',
  GET_CONTRACTIONS_FREQ = 'childbirthOB/GET_CONTRACTIONS_FREQ',
  SET_CONTRACTIONS_FREQ = 'childbirthOB/SET_CONTRACTIONS_FREQ',
  SAVE_CONTRACTIONS_FREQ = 'childbirthOB/SAVE_CONTRACTIONS_FREQ',
  DELETE_CONTRACTIONS_FREQ = 'childbirthOB/DELETE_CONTRACTIONS_FREQ',
  GET_CONTRACTIONS_DUR = 'childbirthOB/GET_CONTRACTIONS_DUR',
  SET_CONTRACTIONS_DUR = 'childbirthOB/SET_CONTRACTIONS_DUR',
  SAVE_CONTRACTIONS_DUR = 'childbirthOB/SAVE_CONTRACTIONS_DUR',
  DELETE_CONTRACTIONS_DUR = 'childbirthOB/DELETE_CONTRACTIONS_DUR',
  GET_VARIABILITY = 'childbirthOB/GET_VARIABILITY',
  SET_VARIABILITY = 'childbirthOB/SET_VARIABILITY',
  SAVE_VARIABILITY = 'childbirthOB/SAVE_VARIABILITY',
  DELETE_VARIABILITY = 'childbirthOB/DELETE_VARIABILITY',
  GET_ACCELERATIONS = 'childbirthOB/GET_ACCELERATIONS',
  SET_ACCELERATIONS = 'childbirthOB/SET_ACCELERATIONS',
  SAVE_ACCELERATIONS = 'childbirthOB/SAVE_ACCELERATIONS',
  DELETE_ACCELERATIONS = 'childbirthOB/DELETE_ACCELERATIONS',
  GET_DECELERATION = 'childbirthOB/GET_DECELERATION',
  SET_DECELERATION = 'childbirthOB/SET_DECELERATION',
  SAVE_DECELERATION = 'childbirthOB/SAVE_DECELERATION',
  DELETE_DECELERATION = 'childbirthOB/DELETE_DECELERATION',
  GET_UC_STRENGTH = 'childbirthOB/GET_UC_STRENGTH',
  SET_UC_STRENGTH = 'childbirthOB/SET_UC_STRENGTH',
  SAVE_UC_STRENGTH = 'childbirthOB/SAVE_UC_STRENGTH',
  DELETE_UC_STRENGTH = 'childbirthOB/DELETE_UC_STRENGTH',
  GET_DTR = 'childbirthOB/GET_DTR',
  SET_DTR = 'childbirthOB/SET_DTR',
  SAVE_DTR = 'childbirthOB/SAVE_DTR',
  DELETE_DTR = 'childbirthOB/DELETE_DTR',
  GET_SIZE = 'childbirthOB/GET_SIZE',
  SET_SIZE = 'childbirthOB/SET_SIZE',
  SAVE_SIZE = 'childbirthOB/SAVE_SIZE',
  DELETE_SIZE = 'childbirthOB/DELETE_SIZE',
  SET_RESPONSE = 'childbirthOB/SET_RESPONSE',
  SET_RESPONSE_PNNV = 'childbirthOB/SET_RESPONSE_PNNV',
  SET_PTA = 'childbirthOB/SET_PTA',
  SAVE_CHILDBIRTHOB = 'childbirthOB/SAVE_CHILDBIRTHOB',
  RESET_STATE = 'childbirthOB/RESET_STATE',
  SET_ADD_TO_TIMELINE = 'childbirthOB/SET_ADD_TO_TIMELINE',
  SET_STATE = 'childbirthOB/SET_STATE',
  SET_DATE_TIME = 'childbirthOB/SET_DATE_TIME',
  SET_ASSESSED_BY = 'childbirthOB/SET_ASSESSED_BY',
  ON_SELECT_CHILDBIRTHOB = 'childbirthOB/ON_SELECT_CHILDBIRTHOB',
  SET_UPDATE_INPUT_ROWS = 'childbirthOB/SET_UPDATE_INPUT_ROWS',
  SET_DATE = 'childbirthOB/SET_DATE',
  SET_TIME = 'childbirthOB/SET_TIME',
  SET_ATTEMPTS = 'childbirthOB/SET_ATTEMPTS',
  SET_PROCEDURE_COMPLICATIONS = 'childbirthOB/SET_PROCEDURE_COMPLICATIONS',
  SET_AUTHORIZATION = 'childbirthOB/SET_AUTHORIZATION',
  SET_SUCCESSFUL_ATTEMPT = 'childbirthOB/SET_SUCCESSFUL_ATTEMPT',
  SET_COMMENTS = 'childbirthOB/SET_COMMENTS',
  SET_ROLE_PERFORMING = 'childbirthOB/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'childbirthOB/SET_ROLE_PERFORMING_PNNV',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'childbirthOB/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'childbirthOB/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
}
